import { createPortal } from "react-dom";
import { useEffect, useState } from "react";

export default function Portal({ children, containerId = "portal-root" }) {
  const [container, setContainer] = useState(null);

  useEffect(() => {
    let el = document.getElementById(containerId);

    if (!el) {
      el = document.createElement("div");
      el.id = containerId;
      document.body.appendChild(el);
    }

    setContainer(el);

    return () => {
      // Optional cleanup: remove container if empty
      if (el && el.childNodes.length === 0) {
        el.remove();
      }
    };
  }, [containerId]);

  if (!container) return null;

  return createPortal(children, container);
}